module.exports = __webpack_public_path__ + "img/bottom-border.379b6056.png";